module.exports = __webpack_public_path__ + "img/qp_logo--white-text--shadow.9f5c4d23.svg";